import { createAsyncAction } from './creator';

export const NOTICE_GET_OVERVIEW = 'NOTICE_GET_OVERVIEW';
export const NOTICE_SET_OVERVIEW = 'NOTICE_SET_OVERVIEW';
export const NOTICE_GET_ALL_MANUAL_TYPE = 'NOTICE_GET_ALL_MANUAL_TYPE';

export const getOverview = createAsyncAction(NOTICE_GET_OVERVIEW);
export const setOverview = createAsyncAction(NOTICE_SET_OVERVIEW);
export const getAllManualType = createAsyncAction(NOTICE_GET_ALL_MANUAL_TYPE);
